<template>
  <div id="MainLoading" :class="{ active: $store.state.loading }">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 481.06 99.32">
      <g id="圖層_2" data-name="圖層 2">
        <g id="圖層_1-2" data-name="圖層 1">
          <polygon
            class="cls-1"
            points="0 34.42 21.23 46.27 21.23 46.29 21.27 46.31 21.27 86.41 25.89 89.36 25.89 48.87 30.2 51.27 30.2 92.11 34.85 95.08 34.85 53.87 39.16 56.28 39.16 97.83 41.49 99.32 43.82 97.83 43.82 53.54 0 29.09 0 34.42"
          />
          <polygon
            class="cls-1"
            points="0 24.7 48.11 51.62 48.11 95.1 52.76 92.13 52.76 48.89 0 19.36 0 24.7"
          />
          <polygon
            class="cls-1"
            points="0 15.03 32.67 33.31 56.99 46.93 56.99 89.42 61.65 86.45 61.65 44.2 0 9.69 0 15.03"
          />
          <polygon
            class="cls-1"
            points="82.98 0.01 41.49 23.22 0 0 0 5.33 64.69 41.54 64.69 44.66 75.45 38.7 82.98 34.49 82.98 29.16 67.54 37.8 63.56 35.57 82.98 24.7 82.98 19.37 58.79 32.9 54.92 30.74 82.98 15.03 82.98 9.7 50.15 28.07 46.26 25.89 82.98 5.34 82.98 0.01"
          />
          <path class="cls-2" d="M156.79,37.09c.26,0-.2,0,0,0Z" />
          <polygon
            class="cls-1"
            points="135.23 43.53 107.15 43.53 107.11 43.63 141.27 75.14 161.83 75.14 141.67 56.51 160.86 56.51 161.18 56.2 147.45 43.53 139.62 43.53 135.23 43.53"
          />
          <path
            class="cls-3"
            d="M160.86,24.18H111.78l.72,4.66-3,8.25h47.3c-.2,0,.26,0,0,0l4.07,3-4.07,3.39h-3.18l10.58,9.76,13.59-13.18.42-1.17Z"
          />
          <polygon
            class="cls-1"
            points="95.64 75.14 114.08 75.14 119.36 60.6 105.56 47.88 95.64 75.14"
          />
          <polygon
            class="cls-2"
            points="287.19 40.14 283.11 37.09 254.24 37.09 248.77 52.08 257.22 43.53 265.95 43.53 283.11 43.53 287.19 40.14"
          />
          <path class="cls-2" d="M283.11,37.09c.26,0-.19,0,0,0Z" />
          <polygon
            class="cls-2"
            points="320.01 60.89 320.01 60.89 319.74 61.27 319.74 61.27 319.11 62.13 319.74 62.13 321.51 62.13 326.31 62.13 339.22 62.13 335.88 39.65 320.01 60.89"
          />
          <path
            class="cls-3"
            d="M208,62.13H188.09l2.12-5.76h19.11l0,0h.08L224.29,43.4H200.84l-8.61,7.5,5-13.75h33.24l4.7-13H183.58L178.2,38.94h0l-.42,1.17h0L165,75.1h51.9l4.58-12.63a3.65,3.65,0,0,0,.19-.34H208Z"
          />
          <polygon
            class="cls-3"
            points="460.85 62.13 453.85 62.13 433.99 62.13 436.11 56.37 455.22 56.37 457.04 54.65 469.96 43.4 468.96 43.4 446.77 43.4 446.51 43.4 438.23 50.6 443.12 37.15 462.51 37.15 472.71 37.15 476.36 37.15 481.06 24.18 467.37 24.18 429.48 24.18 410.94 75.1 448.99 75.1 459.26 75.1 474.11 75.1 480.4 58.15 462.29 58.15 460.85 62.13"
          />
          <path
            class="cls-3"
            d="M287.19,56.51,304.94,39.3,287.19,24.18H238.11l.71,4.66L222,75.14h18.45l6.34-17.49,1.06-.77L267.6,75.14h20.56L268,56.51ZM266,43.53h-8.73l-8.45,8.55,5.47-15h28.87c-.19,0,.26,0,0,0l4.08,3-4.08,3.39Z"
          />
          <path
            class="cls-3"
            d="M393.49,58.15l-1.34,4h-5.07A6.26,6.26,0,0,1,383.67,61a15.24,15.24,0,0,1-3.27-2.88A16.56,16.56,0,0,1,378,54.3a9.26,9.26,0,0,1-1-3.89,14.49,14.49,0,0,1,.77-3.94,16.6,16.6,0,0,1,1.63-3.31,18.85,18.85,0,0,1,2.36-3A12.27,12.27,0,0,1,384.44,38a5.25,5.25,0,0,1,2.64-.82h24l6.46,4.45,1.58-4.45h0l4.58-12.62c.09-.16.16-.28.19-.35H384.2a19.23,19.23,0,0,0-9.61,2.55,30.7,30.7,0,0,0-8,6.48,31.6,31.6,0,0,0-5.47,8.84,24.84,24.84,0,0,0-2,9.51v.19a21.7,21.7,0,0,0,2.74,11.44,20.35,20.35,0,0,0,7.25,7.15A31.1,31.1,0,0,0,379.3,74a62.71,62.71,0,0,0,11.62,1.06h14.54l2.1-5.79h.08l3.95-11.16Z"
          />
          <path
            class="cls-3"
            d="M347.12,24.18H324.21l.68,4.77-9.6,12.45L288.87,75.14l15.89,0h23.45l10.37-9,.86-.75,1.82,9.78h17.1l-7.69-50.92Zm-20.81,38h-7.2l.63-.86h0l.27-.38h0l15.87-21.24,3.34,22.48Z"
          />
        </g>
      </g>
    </svg>
  </div>
</template>
<script>

export default {
  name: "Loading",
  components: {
  },
}
</script>